import { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
// import { generateToken, messaging } from "./notifications/firebase";
// import { onMessage } from "firebase/messaging";
import "./notification.css";

// Notification Component
// const NotificationPopup = ({ title, message, onClose }) => {
//   return (
//     <div className="notification show">
//       <button className="notification-close" onClick={onClose}>×</button>
//       <div className="notification-title">{title}</div>
//       <div>{message}</div>
//     </div>
//   );
// };

const filterEmojis = (value) => {
  // const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83D[\uDE80-\uDEFF])/g;
  const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F)/gu;
  return value.replace(emojiRegex, '');
};

function App() {
  const [notification, setNotification] = useState(null);
  const AppRouter = lazy(() =>
    import("./components/Admin/AdminRoutes/AdminRouteIndex")
  );

  // s

  // useEffect(() => {
  //   generateToken(); // Call the token function only once
  
  //   const unsubscribe = onMessage(messaging, (payload) => {
  //     console.log("notification::::::::::", payload);
      
  //     if (payload.notification) {
  //       setNotification({
  //         title: payload.notification.title,
  //         message: payload.notification.body,
  //       });
  
  //       // Auto-close after 5 seconds
  //       setTimeout(() => setNotification(null), 5000);
  //     }
  //   });
  
  //   return () => unsubscribe(); // Cleanup function to remove the listener
  // }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    const handleInput = (event) => {
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        const filteredValue = filterEmojis(event.target.value);
        if (event.target.value !== filteredValue) {
          event.target.value = filteredValue;
        }
      }
    };
 
    document.addEventListener('input', handleInput);
 
    return () => {
      document.removeEventListener('input', handleInput);
    };
  }, []);

  return (
    <Router>
      <Suspense fallback={<div>loading...</div>}>
        <AppRouter />
      </Suspense>
      {/* {notification && (
        <NotificationPopup
          title={notification.title}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )} */}
    </Router>
  );
}

export default App;
